import * as types from './boards.types';

export const boardTasksSelectors: types.BoardTasksSelectors = {
  selectFreetextValue: (state) => state.filter.inputValue,
  selectFilterDate: (state) => state.filter.date,
  selectFilterMemberIds: (state) => state.filter.memberIds,
};
